import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { NotificationService } from "@progress/kendo-angular-notification";
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';
import * as moment from 'moment'


@Component({
  selector: 'service-reception',  
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css', './styles/styles-loading.css'],
  styles: [`
    form {
      padding: 0 15px 132px 15px;
    }
    .right {
      float: right; 
      position: inherit;
    }
    .title {
      color: #BEBEBE;
      padding-top: 8px;
    }
    .title span.right {
      color: black;
    }
  `],  
  template: `

    <div class="k-block k-block-full" *ngIf="loading">
      <kendo-loader [type]="'converging-spinner'" [size]="'medium'"></kendo-loader>
    </div>

    <div class="wrapper-route-0">

      <form novalidate [formGroup]="form">
        <div class="example-wrapper form-detail">        
          <div class="row">
            <div class="col-field" *ngIf="dataItem != null">
              <kendo-label text="Salida de servicio - Liberación"></kendo-label>              
              <div style="background-color: #{{ dataItem.service_status_color }}; text-align: center; padding: 6px; color: white; margin-top: 8px;">
                {{ dataItem.service_status_name }}
              </div>
              <div class="title no-wrap">
                Fecha y hora de salida: <span class="right">{{ dataItem.output_date }}</span>
              </div>
              <div class="title no-wrap">
                Grúa: <span class="right">{{ dataItem.crane_name }}</span>
              </div>
              <div class="title no-wrap">
                Operador: <span class="right">{{ dataItem.person_operator_name }}</span>
              </div>
              <div class="title no-wrap">
                Destino: <span class="right">{{ dataItem.place }}</span>
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Fecha y hora de entrada:"></kendo-label>
              <kendo-textbox-container>
                <kendo-datepicker formControlName="entry_date" [format]="'dd-MMM-yyyy HH:mm'"></kendo-datepicker>
              </kendo-textbox-container> 
              <div *ngIf="f.entry_date.invalid && (f.entry_date.dirty || f.entry_date.touched)">                  
                <div *ngIf="f.entry_date.errors">
                  <kendo-formerror *ngIf="f.entry_date.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>     
            <div class="col-field">
              <kendo-label text="Estatus:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_service_status" [table]="'services_status'" [valueField]="'id'" [textField]="'name'" [showAll]="true" [extraFilter]="[{field: 'id', operator: 'in', value: '2,3,4'}]"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_service_status.invalid && (f.id_service_status.dirty || f.id_service_status.touched)">                  
                <div *ngIf="f.id_service_status.errors">
                  <kendo-formerror *ngIf="f.id_service_status.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>   
            <div class="col-field" *ngIf="this.form.value.id_service_status == 2">
              <kendo-label text="Forma de pago:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_payment_type" [table]="'payments_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_payment_type.invalid && (f.id_payment_type.dirty || f.id_payment_type.touched)">                  
                <div *ngIf="f.id_payment_type.errors">
                  <kendo-formerror *ngIf="f.id_payment_type.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field" *ngIf="this.form.value.id_service_status == 4">
              <kendo-label text="Cliente:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_customer" [table]="'customers'" [valueField]="'id'" [textField]="'name'" [showAll]="true" (selected)="customerSelected($event)"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_customer.invalid && (f.id_customer.dirty || f.id_customer.touched)">                  
                <div *ngIf="f.id_customer.errors">
                  <kendo-formerror *ngIf="f.id_customer.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field" *ngIf="this.form.value.id_service_status == 2 || this.form.value.id_service_status == 4">
              <kendo-label text="Costo:"></kendo-label>
              <kendo-textbox-container>
                <kendo-numerictextbox formControlName="cost" [format]="'c2'" [min]="0" [autoCorrect]="true"></kendo-numerictextbox>
              </kendo-textbox-container> 
              <div *ngIf="f.cost.invalid && (f.cost.dirty || f.cost.touched)">                  
                <div *ngIf="f.cost.errors">
                  <kendo-formerror *ngIf="f.cost.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div> 
            </div>   
            <div class="col-field">
              <kendo-label text="Núm de factura:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textbox formControlName="invoice"></kendo-textbox>
              </kendo-textbox-container> 
              <div *ngIf="f.invoice.invalid && (f.invoice.dirty || f.invoice.touched)">                  
                <div *ngIf="f.invoice.errors">
                  <kendo-formerror *ngIf="f.invoice.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Observaciones:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textarea formControlName="observations" [rows]="3"></kendo-textarea>
              </kendo-textbox-container> 
              <div *ngIf="f.observations.invalid && (f.observations.dirty || f.observations.touched)">                  
                <div *ngIf="f.observations.errors">
                  <kendo-formerror *ngIf="f.observations.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>        
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="save" themeColor="info" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onSave($event)" [disabled]='!form.valid && !loading' *ngIf="authService.hasPermission(['SALIDAS_SERVICIOS:EDITAR'])"></kendo-floatingactionbutton>

    </div>

    <div kendoDialogContainer></div>

  `    
})
export class ServiceReceptionComponent extends PageBaseComponent implements OnInit {
  
  public id: number = 0;

  public mode = 'CREATE';

  public table: string = 'services_inventories';

  public form!: FormGroup;

  public loading = false;

  public dataItem: any = null;

  private sub: any;


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, protected intl: IntlService, private notificationService: NotificationService, private dialogService: DialogService) { 

    super(authService, router)
    
  }

  //@Override
  protected getFormGroup(dataItem?: any): FormGroup {

    const tzDate = ZonedDate.fromUTCDate(new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),  
      'entry_date': new FormControl(new Date(), Validators.required),
      'id_service_status': new FormControl(2, Validators.required),
      'id_payment_type': new FormControl( 1, Validators.required),
      'cost': new FormControl(0, Validators.required),
      'id_customer': new FormControl(null),
      'credit_days': new FormControl(0),
      'expiration_date': new FormControl(null),
      'invoice': new FormControl(''),
      'observations': new FormControl((dataItem) ? dataItem.observations: ''),
    });

  };

  ngOnInit() {

    // this.form = this.getFormGroup();
    // this.update();

    this.sub = this.route.data.subscribe(v => {
      // console.log(v);
      this.mode = v.mode;
      this.form = this.getFormGroup();
      // if(this.mode == 'CREATE') {

      // }
      // else {
        let id = this.route.snapshot.paramMap.get('id');
        this.id = (id != null) ? parseInt(id): 0;

        // console.log(this.router.getCurrentNavigation());
        this.loading = true;

        this.service.getById(this.table, this.id)
          .subscribe(
            (result: any) => {
              // console.log(result);
              this.dataItem = result;

              this.loading = false;

              this.form = this.getFormGroup(result);
            },
            (error: any) => {
              console.log(error)
              // this.loading = false;
            });

      // }

    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, { 
      entry_date: this.intl.formatDate(formGroup.value.entry_date, "yyyy-MM-dd HH:mm"),
      expiration_date: (formGroup.value.expiration_date != null) ? this.intl.formatDate(formGroup.value.expiration_date, "yyyy-MM-dd"): null,
    });

  };

  public onSave(event: any): void {
  
    if(this.form.valid) {

      let data = this.getData(this.form);
      // console.log('data', data)

      this.loading = true;

      this.service.updateRow(this.table, data) 
        .subscribe(
          (res: any) => {
            console.log("PUT Request is successful: ", this.table, data);
            // console.log("mode = " + this.mode);
            // this.save.emit({mode: this.mode, dataItem: res.data[0]});

            // this.notificationService.show({
            //     content: `Se registró con éxito el costo de grúa de ${this.intl.formatNumber(res.data[0].cost_crane, "c2")}`,
            //     hideAfter: 1000,
            //     position: { horizontal: "center", vertical: "top" },
            //     animation: { type: "fade", duration: 400 },
            //     type: { style: "success", icon: true },
            //   });

            // this.update();

            this.loading = false;

            const dialog: DialogRef = this.dialogService.open({
              title: "Éxito",
              content: `Se editó con éxito ${this.getMessage()}`,
              actions: [{ text: "Ok", primary: true }],
              width: '80%',
              // height: 200,
              // minWidth: 250,
            });
          
            dialog.result.subscribe((result) => {
              if (result instanceof DialogCloseResult) {
                  // console.log("close");
              }
              this.router.navigate(['/services']);
            });

          },
          (fail: any) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 

    }
    
  }

  public goBack() {

      // console.log(event);
    this.router.navigate(['/service_edit/' + this.dataItem.id]);

  }

  public getMessage() {

    return `la salida de servicio de ${this.intl.formatDate(this.dataItem.output_date, "yyyy-MM-dd HH:mm")}, ${this.dataItem.crane_name}, ${this.dataItem.person_operator_name}. ID: [${this.dataItem.id}]?`;

  }

  public customerSelected(sel) : void {

    console.log('VALUE:' + sel.value);
    console.log(sel.item);

    var expiration_date = moment().add(sel.item.credit_days, 'days').format('YYYY-MM-DD');

    this.form.patchValue({
      credit_days: sel.item.credit_days,
      expiration_date: expiration_date
    });

    // this.touched = false;
    // this.numericValueChange();

  }
      
}